<script setup lang="ts">
import { computed, inject } from 'vue'
import { richTextToGovukHtml } from '/@src/utils/richTextToGovukHtml'
import {
  VyzvaSpecificationPublicResponse,
  ZoppmCestneVyhlasenie,
} from '/@src/client-public'
import { poradieComparator } from '/@src/utils/poradieComparator'

const specResponse = inject('specResponse') as VyzvaSpecificationPublicResponse

const cestneVyhlasenia = computed<ReadonlyArray<ZoppmCestneVyhlasenie>>(() => {
  if (!specResponse?.zoppmSpec?.cestneVyhlasenia) {
    return []
  }
  const cestneVyhlasenia = [...specResponse.zoppmSpec.cestneVyhlasenia]
  return cestneVyhlasenia.sort(poradieComparator)
})
</script>

<template>
  <div id="zoppm.ks.vyhlasenie" class="mb-7">
    <template
      v-for="(cestneVyhlasenie, idx) in cestneVyhlasenia"
      :key="cestneVyhlasenie.cestneVyhlasenieSpecId"
    >
      <ValidationFieldReadonlyHidden
        :name="`cestneVyhlasenia[${idx}].zoppmCestneVyhlasenieSpecRef.cestneVyhlasenieSpecRefId`"
        :value="cestneVyhlasenie.cestneVyhlasenieSpecId"
      />
      <ValidationWrapper
        v-slot="{ 'onUpdate:modelValue': update, modelValue, ...slotProps }"
        :name="`cestneVyhlasenia[${idx}].potvrdeneZiadatelom`"
        :value="false"
      >
        <IDSKCheckbox
          :id="cestneVyhlasenie.cestneVyhlasenieSpecId?.toString()"
          v-bind="slotProps"
          :checked="modelValue"
          :model-value="modelValue"
          is-in-checkboxes
          @is-checked="(val) => update(val)"
        >
          <template #default>
            <div v-html="richTextToGovukHtml(cestneVyhlasenie.znenie)" />
          </template>
        </IDSKCheckbox>
      </ValidationWrapper>
    </template>
  </div>
</template>

<style lang="scss">
#zoppm\.ks\.vyhlasenie {
  .cestne-vyhlasenie {
    p {
      margin-bottom: 0;
    }
  }
}
</style>
